import React from 'react';
const investors = [{
  name: 'Alchemist Accelerator',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8fPuayV2SnUujQvMRpPnou/alchemist-logo.png',
  href: 'https://www.alchemistaccelerator.com'
}, {
  name: 'Race Capital',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ob8rkz8khc4heP4HErKArY/race-capital.png',
  href: 'https://www.race.capital'
}, {
  name: 'Antler',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hgirye7hUPRf4DHjevxXfG/antler.png',
  href: 'https://www.antler.co'
}, {
  name: 'Sunset Ventures',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tZ437HpSBjYgAPKabeXyzN/sunset_ventures_light_%281%29.png',
  href: 'https://sunsetventures.xyz'
}, {
  name: 'GoAhead Ventures',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/osi9n4WoHZgnGToFK1vbxz/goahead-ventures.png',
  href: 'https://www.goaheadvc.com/'
}];
export function VCLogos() {
  // Duplicate the list for seamless infinite scroll
  const allLogos = [...investors, ...investors];
  return <section className="relative w-full bg-navy pt-4 pb-8 overflow-hidden" data-id="element-329">
      {/* Top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-330" />

      <p className="text-center text-white/30 text-sm font-medium tracking-[0.2em] uppercase mb-10" data-id="element-331">
        Backed by leading investors
      </p>

      {/* Marquee container */}
      <div className="relative" data-id="element-332">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy to-transparent z-10 pointer-events-none" data-id="element-333" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy to-transparent z-10 pointer-events-none" data-id="element-334" />

        <div className="flex animate-marquee" data-id="element-335">
          {allLogos.map((investor, index) => <a key={`${investor.name}-${index}`} href={investor.href} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 mx-12 flex items-center justify-center group" data-id="element-336">
              <img src={investor.logo} alt={investor.name} className="h-16 w-auto max-w-[240px] object-contain transition-all duration-300 cursor-pointer brightness-0 invert" style={{
            opacity: 0.4
          }} onMouseEnter={e => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.filter = 'brightness(0) invert(1) drop-shadow(0 0 12px rgba(255,255,255,0.4))';
          }} onMouseLeave={e => {
            e.currentTarget.style.opacity = '0.4';
            e.currentTarget.style.filter = 'brightness(0) invert(1)';
          }} data-id="element-337" />
            </a>)}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" data-id="element-338" />
    </section>;
}